module.exports = __webpack_public_path__ + "media/images/new-ui-images/view-gray-519de259da6914770aea34be8fd21641.svg";